<template>
  <div>
    <div class="row">
      <div v-if="energy_suppliers.length > 0" class="col-md-12">
        <table class="table table-striped">
          <thead>
            <th>Name</th>
            <th>Last Import</th>
            <th>Status</th>
          </thead>
          <tbody>
            <tr @click="openAuthenticationPage($event)" class="cursor-pointer">
              <td>{{ energySupplier.name || '-' }}</td>
              <td>{{ energySupplier.last_import || '-' }}</td>
              <td>
                <span
                  v-if="energySupplier.status"
                  class="text-sm px-3 py-2 rounded-full"
                  :class="statusClasses[energySupplier.status]"
                >
                  {{ energySupplier.status }}
                </span>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="col-md-12 text-center">
        <p-button type="warning" @click.native.prevent="openGreenButtonDataImportModal">
          Configure Data Import
        </p-button>
      </div>
    </div>

    <ModalTemplate
      component-name="GreenButtonDataImportModal"
      :data="{
        header: 'Select energy provider',
      }"
      :clicked="greenButtonDataImportModal"
      @update:field="greenButtonDataImportModal = false"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import ModalTemplate from '@/components/modals/ModalTemplate';
import AssignEnergySupplierToCompany from '@/controllers/Consumption/AssignEnergySupplierToCompany';
import PaperTable from '@/components/PaperTable';
export default {
  name: 'AutomaticDataUpload',
  components: { PaperTable, ModalTemplate },
  data() {
    return {
      greenButtonDataImportModal: false,
      energy_suppliers: [],
      statusClasses: {
        connected: 'bg-green-200 text-green-800',
        'not connected': 'bg-red-200 text-red-800',
      },
    };
  },
  computed: {
    energySupplier() {
      return this.energy_suppliers[0];
    },
  },
  created() {
    this.getCompanySuppliers();
  },
  methods: {
    openGreenButtonDataImportModal() {
      this.greenButtonDataImportModal = true;
    },
    async getCompanySuppliers() {
      this.energy_suppliers = await AssignEnergySupplierToCompany.show(this.$store.getters.company.company_id);
    },
    openAuthenticationPage(index) {
      window.open(this.energySupplier.authorization_link, '_self');
    },
  },
};
</script>

<style scoped></style>
